import { FormEvent } from "react"
import FormInput from "../../../../components/FormInput/FormInput"
import FormDropdown from "../../../../components/FormDropdown/FormDropdown"
import { PatchWorkflowInfoFormProps } from "./PatchWorkflowInfoForm.types"
import "./PatchWorkflowInfoForm.css"

const PatchWorkflowInfoForm = (props: PatchWorkflowInfoFormProps) => {

  const {
    filename,
    assetId,
    location,
    assetTemperature,
    assetType,
    insulationMaterial,
    insulationThickness,
    claddingMaterial,
    claddingThickness,
    onSubmit
  } = props

  const submitWorkflow = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <form className="patch-workflow-form-container" onSubmit={submitWorkflow}>
      <div className="asset-info-form-container">
        <h3>Asset information</h3>
        <div className="asset-info-form">
          <FormInput 
            className="asset-id-input"
            label={"Workflow Filename"}
            input={filename}
          />

          <FormInput 
            className="asset-id-input"
            label={"Asset ID"}
            input={assetId}
          />

          <FormDropdown
            label="Location"
            dropdown={location}
          />


          <FormInput 
            label={"Asset Temperature"}
            input={assetTemperature}
          />

          <FormDropdown 
            label={"Asset Type"}
            dropdown={assetType}
          />
       </div>
      </div>

      <div className="patch-insulation-cladding-form-container">
        <div className="asset-info-form-container">
          <h3>Insulation information</h3>

          <div className="patch-insulation-cladding-form">
            <FormDropdown 
              label={"Insulation Material"}
              dropdown={insulationMaterial}
            />

            <FormInput 
              label={"Insulation Thickness"}
              input={insulationThickness}
            />
          </div>
        </div>

        <div className="asset-info-form-container">
          <h3>Cladding information</h3>
          <div className="patch-insulation-cladding-form">
            <FormDropdown
              label={"Cladding Material"}
              dropdown={claddingMaterial}
            />

            <FormInput 
              label={"Cladding Thickness"}
              input={claddingThickness}
            />
          </div>
        </div>
      </div>
    </form>
  )
}

export default PatchWorkflowInfoForm